import React from 'react';
import ReactDOM from 'react-dom';
import './styles.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './fonts/Montserrat/Montserrat-Regular.ttf';

// Include Redux
import Redux from './Redux';

ReactDOM.render(
  <React.StrictMode>
    <Redux>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Redux>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
